<template>
  <div>
    <md-card class="card">
      <md-card-header>
        <div class="md-title">{{$t('Character Status')}}</div>
      </md-card-header>

      <md-card-content>
        <div class="md-layout md-gutter">
          <div class="md-layout-item md-size-33">
            <md-field>
              <label>{{$t('Level')}}</label>
              <md-input v-model="level" type="number"></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-size-66">
            <md-field>
              <label>{{$t('Class')}}</label>
              <md-select v-model="characlass" name="class" id="class">
                <md-option value="0">{{$t('Fighter')}}</md-option>
                <md-option value="1">{{$t('Magician')}}</md-option>
                <md-option value="2">{{$t('Priest')}}</md-option>
                <md-option value="3">{{$t('Knight')}}</md-option>
                <md-option value="4">{{$t('Alchemist')}}</md-option>
              </md-select>
            </md-field>
          </div>

          <div class="md-layout-item md-size-33">
            <md-field>
              <label>{{$t('HP')}}</label>
              <md-input v-model="inputs[0]" type="number"></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-size-33">
            <md-field>
              <label>{{$t('ATK')}}</label>
              <md-input v-model="inputs[1]" type="number"></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-size-33">
            <md-field>
              <label>{{$t('MAT')}}</label>
              <md-input v-model="inputs[2]" type="number"></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-size-33">
            <md-field>
              <label>{{$t('DEF')}}</label>
              <md-input v-model="inputs[3]" type="number"></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-size-33">
            <md-field>
              <label>{{$t('MDF')}}</label>
              <md-input v-model="inputs[4]" type="number"></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-size-33">
            <md-field>
              <label>{{$t('SPD')}}</label>
              <md-input v-model="inputs[5]" type="number"></md-input>
            </md-field>
          </div>
        </div>
      </md-card-content>

      <md-divider />

      <div class="md-layout">
        <div class="md-layout-item md-size-15 md-small-size-33">
          <md-table>
            <md-table-row>
              <md-table-head md-numeric>Level</md-table-head>
            </md-table-row>
            <md-table-row v-for="l in levels" :key="l">
              <md-table-cell md-numeric>{{l}}</md-table-cell>
            </md-table-row>
            <md-table-row>
              <md-table-cell md-numeric>{{output}}</md-table-cell>
            </md-table-row>
          </md-table>
        </div>

        <div class="md-layout-item md-size-85 md-small-size-66">
          <md-table>
            <md-table-row>
              <md-table-head md-numeric>HP</md-table-head>
              <md-table-head md-numeric>ATK</md-table-head>
              <md-table-head md-numeric>MAT</md-table-head>
              <md-table-head md-numeric>DEF</md-table-head>
              <md-table-head md-numeric>MDF</md-table-head>
              <md-table-head md-numeric>SPD</md-table-head>
            </md-table-row>
            <md-table-row v-for="l in levels" :key="l">
              <md-table-cell md-numeric>{{outputs(l)[0]}}</md-table-cell>
              <md-table-cell md-numeric>{{outputs(l)[1]}}</md-table-cell>
              <md-table-cell md-numeric>{{outputs(l)[2]}}</md-table-cell>
              <md-table-cell md-numeric>{{outputs(l)[3]}}</md-table-cell>
              <md-table-cell md-numeric>{{outputs(l)[4]}}</md-table-cell>
              <md-table-cell md-numeric>{{outputs(l)[5]}}</md-table-cell>
            </md-table-row>
            <md-table-row>
              <md-table-cell md-numeric>{{outputs(output)[0]}}</md-table-cell>
              <md-table-cell md-numeric>{{outputs(output)[1]}}</md-table-cell>
              <md-table-cell md-numeric>{{outputs(output)[2]}}</md-table-cell>
              <md-table-cell md-numeric>{{outputs(output)[3]}}</md-table-cell>
              <md-table-cell md-numeric>{{outputs(output)[4]}}</md-table-cell>
              <md-table-cell md-numeric>{{outputs(output)[5]}}</md-table-cell>
            </md-table-row>
          </md-table>
        </div>
      </div>

      <md-card-content>
        <div class="md-layout md-gutter">
          <div class="md-layout-item md-size-33">
            <md-field>
              <label>{{$t('Level')}}</label>
              <md-input v-model="output" type="number" style="width: 64px"></md-input>
            </md-field>
          </div>
        </div>
      </md-card-content>
    </md-card>
  </div>
</template>

<script>
export default {
  name: "Status",
  data() {
    return {
      characlass: 0,
      table: [
        [0.052, 0.055, 0.04, 0.08, 0.071, 0.001],
        [0.052, 0.04, 0.055, 0.071, 0.08, 0.001],
        [0.06, 0.04, 0.04, 0.08, 0.088, 0.001],
        [0.045, 0.04, 0.04, 0.097, 0.088, 0.001],
        [0.047, 0.04, 0.05, 0.071, 0.097, 0.001]
      ],
      level: null,
      inputs: [null, null, null, null, null, null],
      levels: [1, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
      output: null
    };
  },
  methods: {
    outputs(level) {
      var ans = [null, null, null, null, null, null];
      for (var i = 0; i < 6; i++) {
        if (this.level && this.inputs[i] && level) {
          const coef = Math.fround(this.table[this.characlass][i]);
          var a0 = Math.floor(this.inputs[i] / (1 + (this.level - 1) * coef));
          var a1 = Math.ceil(a0 * (1 + (level - 1) * coef));
          ans[i] = a1;
        } else ans[i] = " ";
      }
      return ans;
    }
  }
};
</script>

<style>
.card {
  margin: 8px;
}
</style>
